<script lang="ts">
  import { metatags } from "@roxi/routify";
  import DataAndInsightsPage from "@modern/components/supplier/DataAndInsightsPage.svelte";
  import { onMount } from "svelte";
  import SalesforceChat from "@shared/services/salesforce_chat";

  export let scoped;
  $: ({ user } = scoped);

  metatags.title = "Provi";
  metatags.description = " My Data & Insights";

  onMount(() => {
    SalesforceChat.initialize();
  });
</script>

<DataAndInsightsPage {user} />
